<div class="p-row">
    <div class="p-col-12 p-text-left">
        <label class="label">{{ t('players') }}</label>

            <div class="players" >
                <NormalPlayerItem
                        v-for="(player, index) in playersList"
                        :key="index + '-' + (player ? player.id : index)"
                        :booking_id="match.id"
                        :clubId="clubId"
                        :playerId="player?.id"
                        :index="index"
                        :match="match"
                        @refresh="refresh"
                />

        </div>
    </div>
</div>
